import BaseCommand from "@/models/api/commands/BaseCommand";

export class ReturnBookingItemCommand extends BaseCommand {
  CommandName = "ReturnBookingItem";
  Command: unknown;
  constructor(sessionId: string, operationId: string, orderItemId: string, keepOrderItemFees: boolean) {
    super(sessionId, operationId);
    this.Command = { OrderItemId: orderItemId, KeepOrderItemFees: keepOrderItemFees };
  }
}
